export const protector = {
    state: {
        status: 'idle',
        protector: null
    },
    mutations: {
        SET_PROTECTOR_STATUS(state, status) {
            state.status = status
        },
        SET_PROTECTOR(state, protector) {
            state.protector = protector
        },
        SET_PROTECTOR_FAVORITE(state, isFavorite) {
            state.protector.is_favorite = isFavorite
        }
    },
    actions: {
        fetchProtector({ state, commit }, payload) {
            commit('SET_PROTECTOR', null)
            commit('SET_PROTECTOR_STATUS', 'loading')
            return this.$api.get(`api/protectors/${payload}.json`).then(response => {
                commit('SET_PROTECTOR', response.data.data)
                commit('SET_PROTECTOR_STATUS', 'idle')
            }).catch(error => {
                commit('SET_PROTECTOR_STATUS', 'error')
                return Promise.reject(error)
            })
        },
        protectorFavorite({ dispatch, commit }, payload) {
            commit('SET_PROTECTOR_STATUS', 'settingFavorite')
            return this.$api.patch(`api/protectors/favorite/${payload}.json`, { favorite: true })
                .then(response => {
                    if(response.data.data.is_favorite) {
                        dispatch('addNotification', {
                            type: 'success',
                            content: 'Dodano produkt do ulubionych.'
                        })
                    } else {
                        dispatch('addNotification', {
                            type: 'success',
                            content: 'Usunięto produkt z ulubionych.'
                        })
                    }
                    // dispatch('fetchProtector', payload)
                    commit('SET_PROTECTOR_FAVORITE', response.data.data.is_favorite)
                    commit('SET_PROTECTOR_STATUS', 'idle')
                }).catch(() => {
                    commit('SET_PROTECTOR_STATUS', 'idle')
                    dispatch('fetchProtector', payload)
                    dispatch('addNotification', {
                        type: 'danger',
                        content: 'Wystąpił błąd'
                    })
                })
        }
    },
    getters: {
        protectorStatus: (state) => {
            return state.status
        },
        protector: (state) => {
            if(state.protector) {
                return state.protector
            }
        },
        protectorNote: (state) => {
            if(state.protector && state.protector.notes.length > 0) {
                return state.protector.notes[0].note
            }
        }
    }
}
